import { render, staticRenderFns } from "./PartnerCreation.vue?vue&type=template&id=528bfe14"
import script from "./PartnerCreation.vue?vue&type=script&lang=js"
export * from "./PartnerCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports